import React, { useState } from 'react';
import { withStyles } from '@mui/styles';
import { Box, Paper, Chip, Button } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DocumentMSStyle from './DocumentMSStyle';
import AssignDocumentDialog from './AssignDocumentDialog';

const DocumentDetail = (props) => {
  const { classes, document, onAssignmentSuccess } = props;
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);

  if (!document) {
    return <Box>No document data available</Box>;
  }

  const getStatusBadgeClass = (status) => {
    const statusMap = {
      assigned: classes.statusAssigned,
      sent_via_jiffy: classes.statusSentViaJiffy,
      collected_via_jiffy: classes.statusCollectedViaJiffy,
      sent_via_other: classes.statusSentViaOther,
      processing: classes.statusProcessing,
      completed: classes.statusCompleted,
    };
    return statusMap[status] || classes.statusAssigned;
  };

  return (
    <Box>
      <Box style={{ marginBottom: '24px' }}>
        <Box className={classes.label}>Document Name</Box>
        <Box style={{ fontSize: '18px', fontWeight: 600, color: '#131C4C' }}>
          {document.document_name || '-'}
        </Box>
      </Box>

      <Box style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '24px' }}>
        <Box>
          <Box className={classes.label}>Case Number</Box>
          <Box style={{ fontSize: '14px', color: '#131C4C' }}>
            {document.case_number || '-'}
          </Box>
        </Box>
        <Box>
          <Box className={classes.label}>Client Name</Box>
          <Box style={{ fontSize: '14px', color: '#131C4C' }}>
            {document.client_name || '-'}
          </Box>
        </Box>
        <Box>
          <Box className={classes.label}>Document Type</Box>
          <Box style={{ fontSize: '14px', color: '#131C4C' }}>
            {document.document_type || '-'}
          </Box>
        </Box>
        <Box>
          <Box className={classes.label}>Uploaded By</Box>
          <Box style={{ fontSize: '14px', color: '#131C4C' }}>
            {document.uploaded_by || '-'}
          </Box>
        </Box>
        <Box>
          <Box className={classes.label}>Created At</Box>
          <Box style={{ fontSize: '14px', color: '#131C4C' }}>
            {document.created_at
              ? new Date(document.created_at).toLocaleString()
              : '-'}
          </Box>
        </Box>
        <Box>
          <Box className={classes.label}>Updated At</Box>
          <Box style={{ fontSize: '14px', color: '#131C4C' }}>
            {document.updated_at
              ? new Date(document.updated_at).toLocaleString()
              : '-'}
          </Box>
        </Box>
      </Box>

      {document.description && (
        <Box style={{ marginBottom: '24px' }}>
          <Box className={classes.label}>Description</Box>
          <Box style={{ fontSize: '14px', color: '#131C4C' }}>
            {document.description}
          </Box>
        </Box>
      )}

      {document.files && document.files.length > 0 && (
        <Box style={{ marginBottom: '24px' }}>
          <Box className={classes.label}>Files ({document.files.length})</Box>
          {document.files.map((file, index) => (
            <Paper key={file.id || index} style={{ padding: '16px', marginTop: '12px' }}>
              <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <Box style={{ flex: 1 }}>
                  <Box style={{ fontSize: '14px', fontWeight: 600, color: '#131C4C' }}>
                    File {index + 1}
                  </Box>
                  {file.summary && (
                    <Box style={{ fontSize: '12px', color: '#6E759A', marginTop: '8px' }}>
                      {file.summary}
                    </Box>
                  )}
                  <Box style={{ fontSize: '12px', color: '#131C4C', marginTop: '8px' }}>
                    <a href={file.file_url} target="_blank" rel="noopener noreferrer">
                      View File
                    </a>
                  </Box>
                  {file.created_at && (
                    <Box style={{ fontSize: '12px', color: '#6E759A', marginTop: '4px' }}>
                      Uploaded: {new Date(file.created_at).toLocaleString()}
                    </Box>
                  )}
                </Box>
              </Box>
            </Paper>
          ))}
        </Box>
      )}

      {document.assignments && document.assignments.length > 0 && (
        <Box>
          <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
            <Box className={classes.label}>Assignments ({document.assignments.length})</Box>
            <Button
              className={classes.button}
              startIcon={<AssignmentIcon />}
              onClick={() => setAssignDialogOpen(true)}
              size="small"
            >
              Assign Document
            </Button>
          </Box>
          {document.assignments.map((assignment, index) => (
            <Paper key={assignment.id || index} style={{ padding: '16px', marginTop: '12px' }}>
              <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <Box style={{ flex: 1 }}>
                  <Box style={{ fontSize: '14px', fontWeight: 600, color: '#131C4C' }}>
                    Assigned to: {assignment.assigned_to}
                  </Box>
                  {assignment.notes && (
                    <Box style={{ fontSize: '12px', color: '#6E759A', marginTop: '8px' }}>
                      Notes: {assignment.notes}
                    </Box>
                  )}
                  {assignment.current_status && (
                    <Box style={{ marginTop: '8px' }}>
                      <Chip
                        label={assignment.current_status}
                        className={`${classes.statusBadge} ${getStatusBadgeClass(assignment.current_status)}`}
                        size="small"
                      />
                    </Box>
                  )}
                  {assignment.created_at && (
                    <Box style={{ fontSize: '12px', color: '#6E759A', marginTop: '8px' }}>
                      Created: {new Date(assignment.created_at).toLocaleString()}
                    </Box>
                  )}
                </Box>
              </Box>
            </Paper>
          ))}
        </Box>
      )}

      {(!document.assignments || document.assignments.length === 0) && (
        <Box style={{ marginTop: '24px' }}>
          <Button
            className={classes.button}
            startIcon={<AssignmentIcon />}
            onClick={() => setAssignDialogOpen(true)}
          >
            Assign Document
          </Button>
        </Box>
      )}

      <AssignDocumentDialog
        open={assignDialogOpen}
        onClose={() => setAssignDialogOpen(false)}
        recordId={document.id}
        onSuccess={onAssignmentSuccess}
      />
    </Box>
  );
};

export default withStyles(DocumentMSStyle)(DocumentDetail);

